var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-hero"}},[_c('div',{staticClass:"homeImage"},[_c('parallax',{attrs:{"speedFactor":0.3}},[_c('img',{attrs:{"src":_vm.img}})]),_c('div',{staticClass:"homeCards"},[_c('HeroCard')],1),_c('div',{staticClass:"red"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }